import { useCustomAlert } from "../../alerts";
import useSWRFetcher, { SWRFetchError } from "../fetcher";
import { useCallback, useEffect } from "react";
import useSWR from "swr";
import { SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER } from "../../../../constants/errors";
import {
  BoardDownloadFiles,
  PartShoppingListStatus,
} from "../../../../reducers/uploadedBoard";
import { boardFilesKey } from "./state-machine/boardFiles";

const FILES_REFRESH_INTERVAL = 2000;

export default function useBoardFiles(boardId: string) {
  const customAlert = useCustomAlert();
  const fetcher = useSWRFetcher<BoardDownloadFiles>(undefined);

  // The manufacturing output needs no polling: its state changes arrive over
  // the board's websocket and refetch this key (see state-machine/boardFiles).
  const { data, mutate, error } = useSWR<BoardDownloadFiles, SWRFetchError>(
    boardFilesKey(boardId),
    fetcher,
    {
      refreshInterval: (nextBoardFiles) => {
        if (
          nextBoardFiles?.part_shopping_lists?.status ===
          PartShoppingListStatus.PROCESSING
        ) {
          return FILES_REFRESH_INTERVAL;
        }
        return 0;
      },
    },
  );

  const onError = useCallback(
    (detail?: string) => {
      customAlert(detail || SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER);
    },
    [customAlert],
  );

  useEffect(() => {
    if (error !== undefined) {
      onError();
    }
  }, [error, onError]);

  const refreshBoardFiles = useCallback(
    (boardFiles?: BoardDownloadFiles) => {
      void mutate(boardFiles);
    },
    [mutate],
  );

  return {
    boardFiles: data || null,
    refreshBoardFiles,
  };
}
